
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2 1)","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#4A90E2","d":"M1.633 4.138l1.603-1.603L5.13 3.93l7.877 7.31 1.368 2.432-1.603 1.603-2.033-1.203-7.876-7.876z"}}),_c('path',{attrs:{"fill":"#4A90E2","d":"M14.49 4.138l-1.602-1.603-1.893 1.396-7.878 7.31-1.367 2.432 1.602 1.603 2.034-1.203 7.876-7.876z"}}),_c('path',{attrs:{"fill":"#4A90E2","d":"M6.846.971h2.267l.351 2.326.401 10.74-.752 2.686H6.846l-.587-2.289V3.297z"}}),_c('path',{attrs:{"fill":"#4A90E2","d":"M15.938 10.063V7.796l-2.326-.351-10.74-.401-2.686.752v2.267l2.288.587h11.138z"}}),_c('ellipse',{attrs:{"fill":"#4A90E2","cx":"7.933","cy":"9.001","rx":"5.667","ry":"5.625"}}),_c('ellipse',{attrs:{"cx":"7.933","cy":"9.001","rx":"2.267","ry":"2.25"}}),_c('path',{attrs:{"d":"M1.633 4.138l1.603-1.603L5.13 3.93l7.877 7.31 1.368 2.432-1.603 1.603-2.033-1.203-7.876-7.876z"}}),_c('path',{attrs:{"d":"M14.49 4.138l-1.602-1.603-1.893 1.396-7.878 7.31-1.367 2.432 1.602 1.603 2.034-1.203 7.876-7.876z"}}),_c('path',{attrs:{"d":"M6.846.971h2.267l.351 2.326.401 10.74-.752 2.686H6.846l-.587-2.289V3.297z"}}),_c('path',{attrs:{"d":"M15.938 10.063V7.796l-2.326-.351-10.74-.401-2.686.752v2.267l2.288.587h11.138z"}}),_c('ellipse',{attrs:{"cx":"7.933","cy":"9.001","rx":"5.667","ry":"5.625"}}),_c('ellipse',{attrs:{"fill":"#4A4A4A","cx":"7.933","cy":"9.001","rx":"2.267","ry":"2.25"}})])])
          )
        }
      }
    